export default __webpack_public_path__ + "static/media/delivery@2x.7a5503b4.png";